import {useTranslation} from 'react-i18next'

export function ComingSoonPage() {
  const {t} = useTranslation()

  return (
    <div className='flex flex-1 items-center justify-center px-4 py-16'>
      <div className='flex max-w-md flex-col items-center gap-3 text-center'>
        <h1 className='text-2xl font-semibold tracking-tight'>{t('public.comingSoon.title')}</h1>
        <p className='text-sm text-muted-foreground'>{t('public.comingSoon.description')}</p>
      </div>
    </div>
  )
}
